import { mount } from "@vue/test-utils";
import StepHeader from "@/components/core/StepHeader";

jest.mock("@/components/core/StepHeader", () => ({
  ...jest.requireActual("@/components/core/StepHeader"),
  methods: {
    watch: jest.fn()
  }
}));

describe("StepHeader test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(StepHeader);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component StepHeader", () => {
    expect(wrapper).toBeDefined();
  });
});
